<template>
    <div>
        <div class="row">
            <div class="col-sm-12 hidden-md-up">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link" href="javascript:void(0)" @click.prevent="createNewEmail"><i
                            class="mdi mdi-plus"></i> New Email </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{active:isActiveFolder('inbox')}" href="javascript:void(0)"
                           @click.prevent="selectFolder('inbox')"><i
                            class="mdi mdi-gmail"></i> Inbox </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{active:isActiveFolder('done')}" href="javascript:void(0)"
                           @click.prevent="selectFolder('done')">
                            <i class="mdi mdi-check-all"></i> Done </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{active:isActiveFolder('drafts')}" href="javascript:void(0)"
                           @click.prevent="selectFolder('drafts')"> <i
                            class="mdi mdi-square-edit-outline"></i> Drafts </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{active:isActiveFolder('sent')}" href="javascript:void(0)"
                           @click.prevent="selectFolder('sent')">
                            <i class="mdi mdi-send"></i> Sent </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{active:isActiveFolder('deleted')}" href="javascript:void(0)"
                           @click.prevent="selectFolder('deleted')"> <i
                            class="mdi mdi-delete"></i> Deleted </a>
                    </li>
                    <template v-if="hasFeature('feat_service_provider_portals')">
                        <li class="nav-item" :class="{active:isActiveFolder('redrabbit-messenger')}">
                            <a class="nav-link" href="javascript:void(0)" @click.prevent="selectFolder('redrabbit-messenger')">
                                <i class="mdi mdi-chat-outline"></i> RedRabbit Messenger </a>
                        </li>
                    </template>
                    <template v-if="userCan('manage-saved-replies')">
                        <li class="nav-item" :class="{active:isActiveFolder('saved-replies')}">
                            <a class="nav-link" href="javascript:void(0)" @click.prevent="selectFolder('saved-replies')">
                                <i class="mdi mdi-settings-outline"></i> Saved Replies </a>
                        </li>
                    </template>

                    <template v-if="userCan('manage-saved-replies')">
                        <li class="nav-item" :class="{active:isActiveFolder('communication-scenarios')}">
                            <a class="nav-link" href="javascript:void(0)" @click.prevent="selectFolder('communication-scenarios')">
                                <i class="mdi mdi-settings-outline"></i> Communication Scenarios </a>
                        </li>
                    </template>
                </ul>
            </div>

            <div class="col-lg-3 col-md-4 hidden-sm-down">
                <div class="stickyside">
                    <div class="card-body inbox-panel">
                        <button @click.prevent="fetchIncomingEmails"
                                v-if="app.env !== 'production'"
                                class="btn btn-primary mb-2 btn-block waves-effect waves-light">
                            Fetch emails
                        </button>

                        <button @click.prevent="createNewEmail"
                                class="btn btn-primary mb-4 btn-block waves-effect waves-light">
                            New Email
                        </button>

                        <ul class="list-group list-group-full">
                            <li class="list-group-item" :class="{active:isActiveFolder('inbox')}">
                                <a href="javascript:void(0)" @click.prevent="selectFolder('inbox')"><i
                                    class="mdi mdi-gmail"></i> Inbox </a>
                                <span v-show="emailCounters.unread > 0"
                                      class="badge badge-primary hide-while-loading" data-toggle="tooltip"
                                      title="Unread emails">{{ emailCounters.unread }}
                                </span>
                            </li>
                            <li class="list-group-item" :class="{active:isActiveFolder('done')}">
                                <a href="javascript:void(0)" @click.prevent="selectFolder('done')"> <i
                                    class="mdi mdi-check-all"></i> Done </a>
                            </li>
                            <li class="list-group-item" :class="{active:isActiveFolder('drafts')}">
                                <a href="javascript:void(0)" @click.prevent="selectFolder('drafts')"> <i
                                    class="mdi mdi-square-edit-outline"></i> Drafts </a>
                                <span v-show="emailCounters.drafts > 0"
                                      class="badge badge-primary hide-while-loading" data-toggle="tooltip"
                                      title="Draft Emails">{{ emailCounters.drafts }}
                                </span>
                            </li>
                            <li class="list-group-item" :class="{active:isActiveFolder('sent')}">
                                <a href="javascript:void(0)" @click.prevent="selectFolder('sent')"> <i
                                    class="mdi mdi-send"></i> Sent </a>
                                <span v-show="emailCounters.failed > 0"
                                      class="badge badge-danger hide-while-loading" data-toggle="tooltip"
                                      title="Failed emails">{{ emailCounters.failed }}
                                </span>
                            </li>
                            <li class="list-group-item" :class="{active:isActiveFolder('deleted')}">
                                <a href="javascript:void(0)" @click.prevent="selectFolder('deleted')"> <i
                                    class="mdi mdi-delete"></i> Deleted </a>
                            </li>
                            <div class="dropdown-divider"></div>
                            <li class="list-group-item" :class="{active:isActiveFolder('sms-messages')}">
                                <a href="javascript:void(0)" @click.prevent="selectFolder('sms-messages')">
                                    <i class="mdi mdi-message-text"></i> SMSs </a>
                            </li>
                            <template v-if="hasFeature('feat_service_provider_portals')">
                                <div class="dropdown-divider"></div>
                                <li class="list-group-item whitespace-nowrap" :class="{active:isActiveFolder('redrabbit-messenger')}">
                                    <a href="javascript:void(0)" @click.prevent="selectFolder('redrabbit-messenger')">
                                        <i class="mdi mdi-chat-outline"></i> RedRabbit Messenger </a>
                                </li>
                            </template>
                            <template v-if="userCan('manage-saved-replies')">
                                <div class="dropdown-divider"></div>
                                <li class="list-group-item whitespace-nowrap" :class="{active:isActiveFolder('saved-replies')}">
                                    <a href="javascript:void(0)" @click.prevent="selectFolder('saved-replies')">
                                        <i class="mdi mdi-settings-outline"></i> Saved Replies </a>
                                </li>
                            </template>

                            <template v-if="userCan('manage-saved-replies')">
                                <li class="list-group-item whitespace-nowrap" :class="{active:isActiveFolder('communication-scenarios')}">
                                    <a href="javascript:void(0)" @click.prevent="selectFolder('communication-scenarios')">
                                        <i class="mdi mdi-settings-outline"></i> Communication Scenarios </a>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Email Messages & Threads Panel -->
            <div class="col-lg-9 col-md-8 pt-2" v-if="shouldShowEmails">
                <div class="hide-while-loading" v-if="showMessagesList && !isLoadingThread">
                    <inbox-list :folder="folder"
                                :unread-filter="showingOnlyUnread"
                                @update-email-counters="fetchEmailCounters()"
                                @stick="setSticky()"
                                @view-message="setViewingMessage"
                                @load-thread="loadEmailThread">
                    </inbox-list>
                </div>

                <div v-if="isViewingMessage">
                    <div class="hide-while-loading" v-show="!isLoadingThread">
                        <view-thread :thread="selectedThread"
                                     :context="emailContext"
                                     @close="closeEmailForm"
                                     @forward-thread="threadForwardCreated"
                                     from-inbox-dashboard>
                        </view-thread>
                    </div>
                </div>

                <div v-if="isLoadingThread" class="flex justify-center items-center my-64">
                    <icon-refresh class="h-10 w-10 text-indigo-600 animate-spin"/>
                    Loading...
                </div>
            </div>

            <!-- Saved Replies Panel -->
            <div class="col-lg-9 col-md-8 pt-3 hide-while-loading" v-if="isActiveFolder('saved-replies')">
                <saved-replies-list></saved-replies-list>
            </div>

            <!-- RedRabbit Messenger -->
            <div class="col-lg-9 col-md-8 pt-2 hide-while-loading" v-if="isActiveFolder('redrabbit-messenger')">
                <inbox-channel-list></inbox-channel-list>
            </div>

            <!-- Saved Replies Panel -->
            <div class="col-lg-9 col-md-8 pt-2 hide-while-loading" v-if="isActiveFolder('sms-messages')">
                <sms-messages></sms-messages>
            </div>

            <!-- Communication Scenario Panel -->
            <div class="col-lg-9 col-md-8 pt-2 hide-while-loading" v-if="isActiveFolder('communication-scenarios')">
                <communication-scenarios-list></communication-scenarios-list>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InboxDashboard",

    data () {
        return {
            mailboxFilter: "all",
            folder: "inbox",
            showingOnlyUnread: false,
            newEmail: {},
            isViewingMessage: false,
            isLoadingThread: false,
            selectedThread: {},
            emailCounters: {
                unread: 0,
                drafts: 0,
                failed: 0
            },
            emailContext: {}
        };
    },

    computed: {
        showMessagesList () {
            return !this.isViewingMessage;
        },

        shouldShowEmails () {
            return !this.isActiveFolder("saved-replies")
                && !this.isActiveFolder("sms-messages")
                && !this.isActiveFolder("communication-scenarios")
                && !this.isActiveFolder("redrabbit-messenger");
        },

        shouldHideYScrollBar () {
            return this.isActiveFolder("redrabbit-messenger");
        },
    },

    mounted () {
        this.handleRouteQuery();
        this.fetchEmailCounters();
    },

    updated () {
        //scroll to top and remove the <body>'s scroll bar when on RedRabbit Messenger page.
        this.shouldHideYScrollBar ? window.scrollTo(0, 0) : null;
        this.shouldHideYScrollBar ? document.documentElement.style.overflow = "hidden" : document.documentElement.style.overflow = "auto";
    },

    methods: {
        handleRouteQuery () {
            const url = new URL(document.location);
            const viewThread = url.searchParams.get("show");

            if (viewThread) {
                this.isViewingMessage = true;
                this.loadEmailThread(viewThread);
            }

            const folder = url.searchParams.get("folder");
            if (folder && !this.isViewingMessage) {
                this.selectFolder(folder);
            }

            const showUnread = url.searchParams.get("unread");
            if (showUnread) {
                this.showingOnlyUnread = showUnread === "true";
            }
        },

        pushRouteParam (key, value) {
            let url = new URL(document.location);
            url.searchParams.set(key, value);
            history.pushState(null, null, url);
        },

        clearRouteParam (key) {
            let url = new URL(document.location);
            url.searchParams.delete(key);
            history.pushState(null, null, url);
        },

        isActiveFolder (folder) {
            return this.folder === folder;
        },

        closeEmailForm () {
            this.isViewingMessage = false;
            this.clearRouteParam("show");
            this.setTitle();
            this.fetchEmailCounters();
        },

        threadForwardCreated (thread) {
            this.selectedThread = thread;
        },

        setTitle (title) {
            if (title) {
                document.title = title;
                return;
            }

            document.title = this.emailCounters.unread === 0 ? "Inbox" : "Inbox (" + this.emailCounters.unread + ")";
        },

        fetchIncomingEmails () {
            axios.get("emails/fetch-incoming-emails", {})
            .then((response) => {
                toastr.success(response.data);
                new Promise((resolve) => setTimeout(resolve, 5000)).then(() =>  window.location.reload());
            })
            .catch(errors => {
                toastr.error(errors.message);
            });
        },

        createNewEmail () {
            this.isViewingMessage = true;
            this.isLoadingThread = true;
            this.folder = "inbox";

            axios.post("emails/create", {_method: "POST"})
            .then((response) => {
                this.selectedThread = response.data;
                this.setTitle("New Email");
                this.isLoadingThread = false;
            })
            .catch(errors => {
                this.isViewingMessage = false;
                this.isLoadingThread = false;
                if (errors.response.status !== 402) {
                    toastr.error(errors.message);
                }
            });
        },

        loadEmailThread (threadId) {
            this.pushRouteParam("show", threadId);

            this.isLoadingThread = true;
            axios.get("emails/thread/" + threadId)
            .then((response) => {
                this.selectedThread = response.data;
                this.isLoadingThread = false;
            })
            .catch(errors => {
                toastr.error(errors);
            });

            if (this.folder === "inbox") {
                this.fetchEmailCounters();
            }

        },

        selectFolder (folder) {
            this.isViewingMessage = false;
            this.folder = folder;
            this.clearRouteParam("show");
            this.pushRouteParam("folder", folder);
        },

        fetchEmailCounters () {
            axios.get("/emails/counters", {mailbox: this.mailboxFilter})
            .then((response) => {
                this.emailCounters = response.data;
                if (!this.isViewingMessage) {
                    this.setTitle();
                }
            });
        },

        setSticky () {
            $(".stickyside").stick_in_parent({
                offset_top: 90
            });
        },

        setViewingMessage (viewing) {
            this.isViewingMessage = viewing;
        }
    },
};
</script>
